import PropTypes from 'prop-types';
import { ChevronRight, GripVertical } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { Droppable, Draggable } from '@hello-pangea/dnd';

function DishesList({ categories = [] }) {
    const navigate = useNavigate();

    const handleDishClick = (dishId) => {
        navigate('/dish', {
            state: {
                dishId: dishId,
                returnPage: 'dishes',
                activeTab: 'dishes'
            }
        });
    };

    return (
        <div className="space-y-8">
            {Array.isArray(categories) && categories.length > 0 ? (
                categories.some(category => category?.dishes?.length > 0) ? (
                    categories.map((category) => (
                        category?.dishes?.length > 0 && category?.name && (
                            <div key={category.id || `category-${Math.random()}`} className="mb-4">
                                <h3 className="text-lg font-inter text-ps-blue-dark mb-2 mt-4 underline">
                                    {category.name}
                                </h3>
                                <Droppable droppableId={category.id.toString()}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            className={`space-y-2 mt-2 ${snapshot.isDraggingOver ? 'bg-gray-50' : ''
                                                }`}
                                        >
                                            {category.dishes.map((dish, index) => (
                                                <Draggable
                                                    key={dish.id.toString()}
                                                    draggableId={dish.id.toString()}
                                                    index={index}
                                                >
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            className={`flex items-center justify-between w-full p-3 border-b-[1px] bg-white
                                                                ${snapshot.isDragging ? 'shadow-lg' : ''}
                                                                transition-all duration-200`}
                                                        >
                                                            <div className="flex items-center gap-4 flex-1">
                                                                <div
                                                                    {...provided.dragHandleProps}
                                                                    className="cursor-grab hover:text-ps-blue-dark"
                                                                >
                                                                    <GripVertical className="h-5 w-5 text-gray-400" />
                                                                </div>
                                                                <span
                                                                    className="font-inter cursor-pointer hover:pl-2 transition-all duration-200 flex-1"
                                                                    onClick={() => handleDishClick(dish.id)}
                                                                >
                                                                    {dish.name}
                                                                </span>
                                                            </div>
                                                            <div className="flex items-center gap-6">
                                                                <div className="flex text-black font-inter">
                                                                    <span className="mr-1">&euro;</span>
                                                                    <span className="w-12 text-right">
                                                                        {(dish.price || 0).toFixed(2)}
                                                                    </span>
                                                                </div>
                                                                <ChevronRight className="text-ps-blue-dark" size={20} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </div>
                        )
                    ))
                ) : (
                    <div className="text-center py-8 text-gray-500 font-inter">
                        Er zijn geen gerechten gevonden in het geselecteerde menu
                    </div>
                )
            ) : (
                <div className="text-center py-8 text-gray-500 font-inter">
                    Er zijn geen gerechten gevonden in het geselecteerde menu
                </div>
            )}
        </div>
    );
}

DishesList.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            dishes: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number,
                    name: PropTypes.string.isRequired,
                    productCount: PropTypes.number,
                    price: PropTypes.number,
                })
            )
        })
    )
};

export default DishesList;